var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopicColores(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F3E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E9D5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paletteGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E2E8F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "woodGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#D97706"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#78350F"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "url(#bgGrad)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30, 32)",
    filter: "drop-shadow(0px 3px 2px rgba(107, 33, 168, 0.15))"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-18,-15 C-8,-22 14,-15 18,-6 C22,4 12,20 -2,18 C-10,17 -11,10 -15,10 C-19,10 -24,-4 -18,-15 Z",
    fill: "url(#paletteGrad)",
    stroke: "#CBD5E1",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -10,
    cy: -6,
    r: 3,
    fill: "#E9D5FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -10,
    cy: 5,
    r: 3.5,
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -2,
    cy: 11,
    r: 3.5,
    fill: "#3B82F6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 9,
    r: 3,
    fill: "#10B981"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 0,
    r: 3.5,
    fill: "#F59E0B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: -8,
    r: 3.2,
    fill: "#EC4899"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5, 0) rotate(45)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -24,
    width: 2,
    height: 34,
    fill: "url(#woodGrad)",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: 10,
    width: 3,
    height: 4,
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -1.5,14 L 1.5,14 C 2,16 2,18 0,21 C -2,18 -2,16 -1.5,14 Z",
    fill: "#8B5CF6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicColores);
export default __webpack_public_path__ + "static/media/topic_colores.4ac52101f6d7632525d765364d25ac73.svg";
export { ForwardRef as ReactComponent };